// extracted by mini-css-extract-plugin
export default {"main-container":"pagos_main-container__Rms+2","container":"pagos_container__0Dw7U","title":"pagos_title__16+b7","items-container":"pagos_items-container__gjQPX"};